import { IPageName } from '../../common/types/apiSchema';
import { PathMap } from './paths';

/**
 * Localised URLs for Italy
 */
export const ItPaths: PathMap = {
  [IPageName.collections]: ['/:filterslug/filtra'],
  [IPageName.bookingsPage]: ['/prenotazioni'],
  [IPageName.bookingDetailsPage]: ['/prenotazioni/:bookingId/details'],
  [IPageName.cancellationPage]: ['/prenotazioni/:bookingId/cancellation'],
  [IPageName.instantAccess]: ['/accesso-istantaneo/:affiliate'],
};
